import { render, staticRenderFns } from "./ParentRegisterByLink.vue?vue&type=template&id=e0f1bba4&scoped=true"
import script from "./ParentRegisterByLink.vue?vue&type=script&lang=js"
export * from "./ParentRegisterByLink.vue?vue&type=script&lang=js"
import style0 from "./ParentRegisterByLink.vue?vue&type=style&index=0&id=e0f1bba4&prod&scoped=true&lang=css"
import style1 from "./ParentRegisterByLink.vue?vue&type=style&index=1&id=e0f1bba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f1bba4",
  null
  
)

export default component.exports